import classNames from "classnames";
import { OrderStatusType } from "@models/order";

interface StatusFilterChipsProps {
    /** Currently active status, or null for "All". */
    active: OrderStatusType | null;
    /** Fired with the selected status, or null when "All" is chosen. */
    onSelect: (status: OrderStatusType | null) => void;
}

const CHIPS: { label: string; value: OrderStatusType | null }[] = [
    { label: "All", value: null },
    { label: "Received", value: OrderStatusType.Received },
    { label: "Processing", value: OrderStatusType.Processing },
    { label: "Shipped", value: OrderStatusType.Shipped },
    { label: "Delivered", value: OrderStatusType.Delivered },
    { label: "Cancelled", value: OrderStatusType.Cancelled },
];

export const StatusFilterChips = ({
    active,
    onSelect,
}: StatusFilterChipsProps) => {
    return (
        <div
            className="mt-5 flex flex-wrap gap-2"
            role="group"
            aria-label="Filter by status"
        >
            {CHIPS.map(({ label, value }) => {
                const isActive = active === value;
                return (
                    <button
                        key={label}
                        type="button"
                        aria-pressed={isActive}
                        onClick={() => onSelect(value)}
                        className={classNames(
                            "btn btn-sm rounded-full",
                            isActive
                                ? "btn-primary"
                                : "btn-outline text-neutral",
                        )}
                    >
                        {label}
                    </button>
                );
            })}
        </div>
    );
};
